import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoDialogComponent } from '../../../../shared/dialog/components/dialogs/info-dialog/info-dialog.component';
import { DialogService } from '../../../../shared/dialog/services/dialog.service';
import { PasswordService } from '../password.service';
import { PasswordResetError } from './password-reset-error';

import { PasswordResetModel } from './password-reset-model';

@Component({
  selector: 'password-reset',
  templateUrl: './password-reset.component.html',
})
export class PasswordResetComponent implements OnInit {

  public passwordResetInformation: PasswordResetModel;
  public errorMessages: PasswordResetError;
  public loading: boolean = false;
  public ready: boolean = false;

  /**
   * Constructor
   *
   * @param {PasswordService} passwordService
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {DialogService} dialogService
   */
  public constructor(
    private passwordService: PasswordService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
  ) {

    this.passwordResetInformation = new PasswordResetModel(
      route.snapshot.params.hash,
      route.snapshot.params.token,
    );

    this.errorMessages = {email: [], password: []};
  }

  /**
   * On initialization
   *
   * @return void
   */
  public ngOnInit(): void {
    this.passwordService.canResetPassword(
      this.route.snapshot.params.hash,
      this.route.snapshot.params.token,
    ).subscribe(
      (allowed: boolean) => {
        if (allowed) {
          this.ready = true;
        } else {
          this.showErrorDialog();
        }
      },
      () => {
        this.showErrorDialog();
      },
    );
  }

  /**
   * Submit the reset form
   *
   * @return void
   */
  public onSubmit(): void {
    this.loading = true;
    this.passwordService.sendPasswordReset(this.passwordResetInformation).subscribe(
      (response: {message: {title: string, text: string}}) => {
        const data = response.message;
        const dialog = this.dialogService.open(InfoDialogComponent, data);

        dialog.dialogClosed().subscribe(
          () => {
            this.router.navigate(['/']).then();
          },
        );

      },
      (error) => {
        if (error.error.error_messages) {
          this.errorMessages = error.error.error_messages;
        } else {
          const data = error.error.message;

          const dialog = this.dialogService.open(InfoDialogComponent, data);

          if (error.error.token === false) {
            dialog.dialogClosed().subscribe(
              () => {
                this.router.navigate(['/']).then();
              },
            );
          }
        }
        this.loading = false;

      },
    );
  }

  /**
   * When the email is changed,
   * reset the error message for email
   *
   * @return void
   */
  public emailChanged(): void {
    this.errorMessages.email = [];
  }

  /**
   * When the password or password confirm is changed,
   * reset the error message for password
   *
   * @return void
   */
  public passwordChanged(): void {
    this.errorMessages.password = [];
  }

  /**
   * Showing the error dialog when a password reset token fails to validate
   *
   * @return void
   */
  private showErrorDialog(): void {
    const data = {title: '', text: 'auth.message.token_invalid'};
    this.dialogService.open(InfoDialogComponent, data);

    this.router.navigate(['/']);
  }
}
